import InternalBookingCardBase from '../common/InternalBookingCardBase';
import { extractUpgradeSymbols } from '../../../../util/upgradeSymbolsHelper';

function BookingCardAxev2({
  booking,
  handleOpenModal,
  renderAvailableSlots,
  rowHeight,
  onBookingShift,
  entertainment,
  onDragStart,
  onDragActivated,
  onDragEnd,
  availableShiftTimes,
  isShiftable,
}) {
  // Axe cards show persons; laneCount is only a fallback for legacy/incomplete data.
  const getParticipantCount = bk => {
    const raw = bk?.participantCount ?? bk?.groupParticipantCount ?? bk?.laneCount ?? 0;
    const n = Number(raw);
    return Number.isFinite(n) ? n : 0;
  };
  const color = '#ffffff';

  const upgradeSymbols = extractUpgradeSymbols(booking);

  const handleCardClick = (bookingId, color) => {
    handleOpenModal(bookingId, color);
  };

  return (
    <InternalBookingCardBase
      booking={booking}
      getParticipantCount={getParticipantCount}
      onCardClick={handleCardClick}
      renderAvailableSlots={renderAvailableSlots}
      rowHeight={rowHeight}
      onBookingShift={onBookingShift}
      entertainment={entertainment}
      onDragStart={onDragStart}
      onDragActivated={onDragActivated}
      onDragEnd={onDragEnd}
      availableShiftTimes={availableShiftTimes}
      isShiftable={isShiftable}
      iconProps={{
        upgrades: upgradeSymbols,
        manualUpgrades: [],
        participantCount: getParticipantCount(booking),
        slotMode: false,
        color,
      }}
      color={color}
    />
  );
}

export default BookingCardAxev2;
